import {FETCH_STEPS} from "./actions";
import {StepItem} from "./types";

const initialState: StepItem[] = [];

export function stepsReducer(
    state = initialState,
    action: any
): StepItem[] {
    switch (action.type) {
        case FETCH_STEPS: {
            return action.payload.steps;
        }
        default:
            return state
    }
}
